import { render, staticRenderFns } from "./EmployeesList.vue?vue&type=template&id=550a90ee&"
import script from "./EmployeesList.vue?vue&type=script&lang=ts&"
export * from "./EmployeesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports